export default __webpack_public_path__ + "static/ProductsServices-9d3fa53e0e5bb5d1d4609b6c2e71dae6.png";